import { server } from '@/services'
import transformJson from '@/utils/transformJson'
import moment from 'moment'

const state = {
  vehicles: [],
  dashboardItems: [],
  fields: [],
  damageData: {},
  zones: [],
  stations: []
}

const actions = {
  getVehicleList({ commit, getters }, params) {
    return new Promise((resolve, reject) => {
      server.get('/ops/getVehicleList', params).then(({ data }) => {
        let vehicles = transformJson(data.msgContent.data, true)
        const fields = Object.keys(vehicles[0]).map((k) => {
          if (k !== 'vehicleId') {
            return {
              key: k,
              sortable: true
            }
          }
          return null
        })
        vehicles = vehicles.map((v) => ({
          ...v,
          _rowVariant: getRowVariant(v)
        }))
        let dashboardItems = vehicles.filter((v) => {
          return v._rowVariant === 'danger' &&
            v.timeDue && v.daysDifference
        })
        dashboardItems = dashboardItems.map((v) => {
          const { _rowVariant, ...rest } = v
          return {
            ...rest,
            isDanger: _rowVariant === 'danger'
          }
        })

        if (params && params.colourCode) {
          vehicles = vehicles.filter((v) => v._rowVariant === params.colourCode)
        }
        commit('SET_DATA', { vehicles, dashboardItems, fields })
        resolve()
      })
    })
  },
  getServiceMonitoring (_, params) {
    return new Promise((resolve, reject) => {
      server.get('/ops/getServiceMonitoring', params).then(({data}) => {
        if (data.msgContent.data.length) {
          resolve(transformJson(data.msgContent.data[0], true))
        }
      }).catch((err) => reject(err))
    })
  },
  upsertServiceMonitoring (_, payload) {
    return server.post('/ops/upsertServiceMonitoring', payload)
  },
  saveChecklist (_, payload) {
    return server.post('/ops/insertFCS', payload)
  },
  uploadDamage (_, payload) {
    return server.post('/ops/uploadDRC', payload)
  },
  getDamage ({ commit }, params) {
    return new Promise((resolve, reject) => {
      server.get('/ops/getDRC', params).then(({ data }) => {
        commit('SET_DATA', { damageData: transformJson(data.msgContent.data, true) })
        resolve()
      }).catch((err) => reject(err))
    })
  },
  fetchZones ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getZones').then(
        resp => {
          let zones = transformJson(resp.data.msgContent.data, true)
          commit('SET_DATA', { zones })
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchStations ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getStations').then(
        resp => {
          let stations = transformJson(resp.data.msgContent.data, true)
          commit('SET_DATA', { stations: stations.sort((a,b) => a.name.localeCompare(b.name)) })
          resolve()
        },
        err => reject(err)
      )
    })
  },
  sortDashboardItems ({ state, commit }, { sortBy, sortOrder }) {
    const tmp = JSON.parse(JSON.stringify(state.dashboardItems))
    const items = tmp.sort((a, b) => {
      if (sortBy === 'timeDue') {
        return sortOrder === 'asc' ? moment(a.timeDue) - moment(b.timeDue)
          : moment(b.timeDue) - moment(a.timeDue)
      }
      if (sortBy === 'daysDifference') {
        return sortOrder === 'asc' ? a.daysDifference - b.daysDifference
          : b.daysDifference - a.daysDifference
      }
    })
    commit('SET_DATA', { dashboardItems: items })
  }
}

const mutations = {
  SET_DATA(state, payload) {
    Object.keys(payload).forEach((k) => {
      state[k] = payload[k]
    })
  }
}

function getRowVariant(item) {
  if (item.daysDifference <= 1) {
    return 'danger'
  } else if (1 < item.daysDifference < 15 || item.mileageDifference < 1000) {
    return 'warning'
  }
  return 'success'
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}